import {AnalyticsEventTypeI, AnalyticsProviderInterface} from '../analytics.provider.i';

const gtmWidget = require('./widgets/gtm.widget.js');

export class GtmAnalyticsProvider implements AnalyticsProviderInterface {
    private widget = gtmWidget;

    constructor(token: string) {
        this.widget.init(token);
    }

    trackEvent<T extends keyof AnalyticsEventTypeI>(event_type: T, event_data: any, cb?: () => void): void {
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/utils/analytics/providers/gtm.analytics.provider.ts